import { useRef } from 'react';
import type { TopicAttachmentDto } from '../api/types';

export const topicAttachmentUrl = (topicId: string, id: string) =>
  `/api/topics/${encodeURIComponent(topicId)}/attachments/${encodeURIComponent(id)}`;
export function TopicAttachmentList({
  topicId,
  attachments,
  onRemove,
}: {
  topicId: string;
  attachments: TopicAttachmentDto[];
  onRemove?: (id: string) => void;
}) {
  return (
    <ul className="topic-attachments">
      {attachments.map((attachment) => (
        <li key={attachment.id}>
          <a href={topicAttachmentUrl(topicId, attachment.id)} target="_blank" rel="noreferrer">
            {attachment.mimeType.startsWith('image/') ? (
              <img
                src={topicAttachmentUrl(topicId, attachment.id)}
                alt={`Prévia de ${attachment.name}`}
              />
            ) : (
              <span className="topic-file-kind">ARQUIVO</span>
            )}
            <span>
              {attachment.name}
              <small>
                {Math.max(1, Math.ceil(attachment.size / 1024))} KB
                {attachment.mimeType === 'application/octet-stream'
                  ? ' · download, sem leitura automática'
                  : attachment.mimeType === 'application/pdf'
                    ? ' · leitura do texto'
                    : ''}
              </small>
            </span>
          </a>
          {onRemove ? (
            <button
              type="button"
              onClick={() => onRemove(attachment.id)}
              aria-label={`Remover ${attachment.name}`}
            >
              Remover
            </button>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
export function TopicAttachButton({
  onFiles,
  disabled,
}: {
  onFiles: (files: File[]) => void;
  disabled: boolean;
}) {
  const input = useRef<HTMLInputElement>(null);
  return (
    <>
      <input
        ref={input}
        type="file"
        multiple
        hidden
        aria-label="Escolher arquivos"
        onChange={(event) => {
          onFiles(Array.from(event.target.files ?? []));
          event.target.value = '';
        }}
      />
      <button
        type="button"
        className="topic-attach"
        disabled={disabled}
        onClick={() => input.current?.click()}
        title="Imagens e arquivos · até 4 anexos de 10 MB. Também pode colar uma imagem."
      >
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          width="18"
          height="18"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
        >
          <path d="m8 13 7-7a3 3 0 0 1 4 4L9 20a5 5 0 0 1-7-7L13 2" />
          <path d="m5 15 9-9" />
        </svg>
        Anexar
      </button>
    </>
  );
}
